import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import lot_coin from './lottery_assets/lot_low.svg'

import './lottery_styles/lotterymystery.css';

export default function LotteryMystery() {
  return (
    <>
    <div className='lot_mystery'>
      <Container>
        <Row className='lot_mys'>
          <Col lg={2} md={4} sm={6} xs={6} className="d-flex justify-content-center align-items-center my-1 mt-5">
            <div className="lot_low_1">
              <div className="lot_low_11">
                <img src={lot_coin} alt="" />
              </div>
            </div>     
          </Col>
          <Col lg={2} md={4} sm={6} xs={6} className="d-flex justify-content-center align-items-center my-1 mt-5">
            <div className="lot_low_2">
              <div className="lot_low_22">
                <img src={lot_coin} alt="" />
              </div>
            </div>  
          </Col>
          <Col lg={2} md={4} sm={6} xs={6} className="d-flex justify-content-center align-items-center my-1 mt-5">
            <div className="lot_low_3">
              <div className="lot_low_33">
                <img src={lot_coin} alt="" />
              </div>
            </div>  
          </Col>
          <Col lg={2} md={4} sm={6} xs={6} className="d-flex justify-content-center align-items-center my-1 mt-5">
            <div className="lot_low_4">
              <div className="lot_low_44">
                <img src={lot_coin} alt="" />
              </div>
            </div>  
          </Col>
          <Col lg={2} md={4} sm={6} xs={6} className="d-flex justify-content-center align-items-center my-1 mt-5">
            <div className="lot_low_5">
              <div className="lot_low_55">
                <img src={lot_coin} alt="" />
              </div>
            </div>  
          </Col>
          <Col lg={2} md={4} sm={6} xs={6} className="d-flex justify-content-center align-items-center my-1 mt-5">
            <div className="lot_low_6">
              <div className="lot_low_66">
                <img src={lot_coin} alt="" />
              </div>
            </div>  
          </Col>
        </Row>
      </Container>
    </div>
    </>
  )
}
